(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:app
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .constant('AdmConstant', {
      'SERVER_PATH_ADMINISTRACIO': 'security/',
      'SERVER_PATH_ADMINISTRACIO_API': 'api/security/',
      'SERVER_ADMINISTRACIO_VERSION' : 'v1'
    });
}());
